import { HistoricalYieldFees } from '../../core/entities/general/HistoricalYieldFees.entity';
import { YieldFeesChart } from '../../core/entities/general/YieldFeesChart.entity';
import { YieldFeesTraceResponse } from '../interfaces/yield-fees-trace.interface';

export class YieldFeesTraceMapper {
  static fromResponseToEntity(
    response: YieldFeesTraceResponse
  ): YieldFeesChart {
    return new YieldFeesChart(
      response.totalYield,
      response.totalFees,
      response.totalNetRevenue,
      response.historical.map(
        (historical) =>
          new HistoricalYieldFees(
            historical.label,
            historical.yield,
            historical.fees,
            historical.netRevenue
          )
      )
    );
  }
}
